module.exports = __webpack_public_path__ + "img/kiosk-icon.c7eb33d4.webp";